export class AmbienteConfig {


  private static ambientesKeyds = new Map<string, string>()

  // ----  PRD  ----
  .set('https://healthlog.healthmap.com.br', 'adm')
  .set('https://healthlog-cnu.healthmap.com.br', 'cnu')
  .set('https://healthlog-ujf.healthmap.com.br', 'ujf')
  .set('https://healthlog-unimedcerrado.healthmap.com.br', 'unimedcerrado')
  .set('https://healthlog-unimedpoa.healthmap.com.br', 'unimedpoa')
  .set('https://healthlog-unimed014.healthmap.com.br', 'unimed014')
  .set('https://healthlog-institutopaulucci.healthmap.com.br', 'paulucci')
  .set('https://healthlog-clinicadoc.healthmap.com.br', 'clinicadoc')
  .set('https://healthlog-unafisco.healthmap.com.br', 'unafisco')
  .set('https://healthlog-unimedvsf.healthmap.com.br', 'unimedvsf')
  .set('https://healthlog-camed.healthmap.com.br', 'camed')

  // ----  HEALTHLOG_HMG  ----
  .set('https://healthlog-homolog.healthmap.com.br', 'hmg')
  .set('https://healthlog-ui-homolog.healthmap.com.br', 'hmg')

  // ----  DEV  ----
  .set('http://localhost:4200', 'dev')
  ;


  private static apiURLs = new Map<string, string>()

  // ----  HEALTHLOG_HMG  ----
  .set('https://healthlog-homolog.healthmap.com.br', 'https://healthlog-api-homolog.healthmap.com.br')
  .set('https://healthlog-ui-homolog.healthmap.com.br', 'https://healthlog-api-homolog.healthmap.com.br')

  // ----  DEV  ----
  .set('http://localhost:4200', 'http://localhost:8085')
  ;

  constructor() { }

  public static getKeyDS(): string {
    const keyDS = AmbienteConfig.ambientesKeyds.get(document.location.origin);
    console.log('ambiente.config: getKeyDs: location = ' + document.location.origin + ' , keyDS: ' + keyDS);

    if (!keyDS) {
      console.error('favor verificar as configuracoes de ambiente. URL nao encontrada: ' + document.location.origin);
      alert('URL não encontrada na configuração de ambiente.');
    }
    return keyDS;
  }

  public static getApiURL(): string {
    const apiURL = AmbienteConfig.apiURLs.get(document.location.origin);

    if ( apiURL ) {
      console.log('ambiente.config: apiURL: location = ' + document.location.origin + ' , apiURL: ' + apiURL);
      return apiURL;
    }

    return 'https://healthlog-api.healthmap.com.br';

  }
}
